(function ( $ ) {

    $.fn.press = function() {
        var that = this,
            current_page = 0,
            has_more = true,
            countFinder = /<\!--COUNT:(\d+?)-->/i;

        function hideLoadMoreButton() {
            $('.js-load-more').hide();
        }
        function showLoadMoreButton() {
            $('.js-load-more').show();
        }

        function getPress(replace) {

            $.post(
                ajaxurl,
                {
                    'action': 'get_press',
                    'current_page': current_page
                },
                function(res)
                {
                    var matches = countFinder.exec(res),
                        count = parseInt(matches[1]);

                    if (count < 12) {
                        hideLoadMoreButton();
                    } else {
                        showLoadMoreButton();
                    }
                    if (replace) {
                        that.html(res);
                        current_page = 0;
                    } else {
                        that.append(res);
                    }

                    // asyncImg(function(){
                    //     initToShow();
                    // });

                    // asyncBg(function(){
                    //     initToShow();
                    //     initCarousel();
                    // });
                }
            );
        }

        getPress(true);

        $('.js-load-more').click(function() {
            current_page = current_page + 1;
            getPress(false);
        });
    }

}( jQuery ));

$(function() {
    if ($('#js-press').length) {
        $('#js-press').press();
    }
});
